import { useEffect, useState } from 'react';
import { Search, X } from 'lucide-react';
import { useCouponFilters } from '../store/filters.store';
import { COUPON_STATUSES, type CouponStatus } from '../types';

export function CouponFilters() {
  const f = useCouponFilters();
  const hasFilters = !!(f.search || f.status);
  // Debounced: the store (and so the list query) only sees the search after 300 ms of no typing.
  const [text, setText] = useState(f.search ?? '');
  const { setFilter } = f;
  useEffect(() => {
    const t = setTimeout(() => setFilter('search', text), 300);
    return () => clearTimeout(t);
  }, [text, setFilter]);
  // Keep the box in sync when the store changes elsewhere (e.g. "Clear").
  useEffect(() => setText(f.search ?? ''), [f.search]);

  return (
    <div className="glass-panel rounded-xl p-4 flex flex-wrap items-center gap-3">
      <div className="relative flex-1 min-w-[220px]">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-on-surface-variant" />
        <input
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Search code or label"
          aria-label="Search coupons"
          className="w-full pl-9 pr-3 py-2 rounded-lg bg-surface-container-lowest border border-border-subtle text-sm focus:outline-none focus:ring-2 focus:ring-electric-violet/30"
        />
      </div>
      <label className="flex items-center gap-2 text-xs">
        <span className="text-on-surface-variant uppercase tracking-widest font-bold">Status</span>
        <select
          value={f.status ?? ''}
          onChange={(e) => f.setFilter('status', (e.target.value || undefined) as CouponStatus | undefined)}
          className="px-2 py-1.5 rounded-md bg-surface-container-lowest border border-border-subtle text-sm focus:outline-none focus:ring-2 focus:ring-electric-violet/30"
        >
          <option value="">All</option>
          {COUPON_STATUSES.map((s) => (
            <option key={s} value={s}>
              {s.charAt(0) + s.slice(1).toLowerCase()}
            </option>
          ))}
        </select>
      </label>
      {hasFilters && (
        <button
          onClick={() => f.reset()}
          className="ml-auto flex items-center gap-1 text-xs text-on-surface-variant hover:text-on-surface"
        >
          <X className="w-3 h-3" /> Clear
        </button>
      )}
    </div>
  );
}
